export const banks = [
  { codigo: '033', banco: 'BCO SANTANDER (BRASIL) S.A.' },
  { codigo: '341', banco: 'ITAÚ UNIBANCO S.A.	' },
  { codigo: '001', banco: 'BCO DO BRASIL S.A.' },
  { codigo: '104', banco: 'CAIXA ECONOMICA FEDERAL	' },
  { codigo: '237', banco: 'BCO BRADESCO S.A.	' },
  { codigo: '260', banco: 'NU PAGAMENTOS - IP	' },
  { codigo: '077', banco: 'BANCO INTER' },
  { codigo: '336', banco: 'BCO C6 S.A.	' },
  { codigo: '380', banco: 'PICPAY	' },
  { codigo: '348', banco: 'BCO XP S.A.	' },
  { codigo: '184', banco: 'BCO ITAÚ BBA S.A.	' },
  { codigo: '756', banco: 'BANCO SICOOB S.A.' },
  { codigo: '208', banco: 'BANCO BTG PACTUAL S.A.	' },
  { codigo: '422', banco: 'BCO SAFRA S.A.	' },
  { codigo: '655', banco: 'BCO VOTORANTIM S.A.	' },
  { codigo: '323', banco: 'MERCADO PAGO IP LTDA.	' },
  { codigo: '003', banco: 'BCO DA AMAZONIA S.A.' },
  { codigo: '004', banco: 'BCO DO NORDESTE DO BRASIL S.A.' },
  { codigo: '007', banco: 'BNDES' },
  { codigo: '010', banco: 'CREDICOAMO' },
  { codigo: '011', banco: 'C.SUISSE HEDGING-GRIFFO CV S/A' },
  { codigo: '012', banco: 'BANCO INBURSA' },
  { codigo: '014', banco: 'STATE STREET BR S.A. BCO COMERCIAL' },
  { codigo: '015', banco: 'UBS BRASIL CCTVM S.A.' },
  { codigo: '016', banco: 'CCM DESP TRÂNS SC E RS' },
  { codigo: '017', banco: 'BNY MELLON BCO S.A.' },
  { codigo: '018', banco: 'BCO TRICURY S.A.' },
  { codigo: '021', banco: 'BCO BANESTES S.A.' },
  { codigo: '024', banco: 'BCO BANDEPE S.A.' },
  { codigo: '025', banco: 'BCO ALFA S.A.' },
  { codigo: '029', banco: 'BANCO ITAÚ CONSIGNADO S.A.' },
  { codigo: '036', banco: 'BCO BBI S.A.' },
  { codigo: '037', banco: 'BCO DO EST. DO PA S.A.' },
  { codigo: '040', banco: 'BCO CARGILL S.A.' },
  { codigo: '041', banco: 'BCO DO ESTADO DO RS S.A.' },
  { codigo: '047', banco: 'BCO DO EST. DE SE S.A.' },
  { codigo: '060', banco: 'CONFIDENCE CC S.A.' },
  { codigo: '062', banco: 'HIPERCARD BM S.A.' },
  { codigo: '063', banco: 'BANCO BRADESCARD	' },
  { codigo: '064', banco: 'GOLDMAN SACHS DO BRASIL BM S.A' },
  { codigo: '065', banco: 'BCO ANDBANK S.A.' },
  { codigo: '066', banco: 'BCO MORGAN STANLEY S.A.' },
  { codigo: '069', banco: 'BCO CREFISA S.A.	' },
  { codigo: '070', banco: 'BRB - BCO DE BRASILIA S.A.' },
  { codigo: '074', banco: 'BCO. J.SAFRA S.A.' },
  { codigo: '075', banco: 'BCO ABN AMRO S.A.' },
  { codigo: '076', banco: 'BCO KDB BRASIL S.A.' },
  { codigo: '078', banco: 'HAITONG BI DO BRASIL S.A.' },
  { codigo: '079', banco: 'BCO ORIGINAL DO AGRO S/A	' },
  { codigo: '080', banco: 'B&T CC LTDA.	' },
  { codigo: '081', banco: 'BANCOSEGURO S.A.	' },
  { codigo: '082', banco: 'BANCO TOPÁZIO S.A.	' },
  { codigo: '083', banco: 'BCO DA CHINA BRASIL S.A.	' },
  { codigo: '084', banco: 'UNIPRIME DO BRASIL - CC LTDA.	' },
  { codigo: '085', banco: 'COOPCENTRAL AILOS	' },
  { codigo: '088', banco: 'BANCO RANDON S.A.	' },
  { codigo: '089', banco: 'CREDISAN CC	' },
  { codigo: '091', banco: 'CCCM UNICRED CENTRAL RS	' },
  { codigo: '092', banco: 'BRK S.A. CFI	' },
  { codigo: '093', banco: 'POLOCRED SCMEPP LTDA.	' },
  { codigo: '094', banco: 'BANCO FINAXIS	' },
  { codigo: '095', banco: 'TRAVELEX BANCO DE CÂMBIO S.A.	' },
  { codigo: '096', banco: 'BCO B3 S.A.	' },
  { codigo: '097', banco: 'CREDISIS CENTRAL DE COOPERATIVAS DE CRÉDITO LTDA.	' },
  { codigo: '098', banco: 'CREDIALIANÇA CCR	' },
  { codigo: '099', banco: 'UNIPRIME CENTRAL CCC LTDA.	' },
  { codigo: '100', banco: 'PLANNER CV S.A.	' },
  { codigo: '101', banco: 'RENASCENCA DTVM LTDA	' },
  { codigo: '102', banco: 'XP INVESTIMENTOS CCTVM S/A	' },
  { codigo: '105', banco: 'LECCA CFI S.A.	' },
  { codigo: '107', banco: 'BCO BOCOM BBM S.A.	' },
  { codigo: '108', banco: 'PORTOCRED S.A. - CFI	' },
  { codigo: '111', banco: 'OLIVEIRA TRUST DTVM S.A.	' },
  {
    codigo: '114',
    banco: 'CENTRAL COOPERATIVA DE CRÉDITO NO ESTADO DO ESPÍRITO SANTO	',
  },
  { codigo: '117', banco: 'ADVANCED CC LTDA	' },
  { codigo: '119', banco: 'BCO WESTERN UNION	' },
  { codigo: '120', banco: 'BCO RODOBENS S.A.	' },
  { codigo: '121', banco: 'BCO AGIBANK S.A.	' },
  { codigo: '122', banco: 'BCO BRADESCO BERJ S.A.	' },
  { codigo: '124', banco: 'BCO WOORI BANK DO BRASIL S.A.	' },
  { codigo: '125', banco: 'BANCO GENIAL	' },
  { codigo: '126', banco: 'BR PARTNERS BI	' },
  { codigo: '127', banco: 'CODEPE CVC S.A.	' },
  { codigo: '128', banco: 'MS BANK S.A. BCO DE CÂMBIO	' },
  { codigo: '129', banco: 'UBS BRASIL BI S.A.	' },
  { codigo: '130', banco: 'CARUANA SCFI	' },
  { codigo: '131', banco: 'TULLETT PREBON BRASIL CVC LTDA	' },
  { codigo: '132', banco: 'ICBC DO BRASIL BM S.A.	' },
  { codigo: '133', banco: 'CRESOL CONFEDERAÇÃO	' },
  { codigo: '134', banco: 'BGC LIQUIDEZ DTVM LTDA	' },
  { codigo: '136', banco: 'CONF NAC COOP CENTRAIS UNICRED	' },
  { codigo: '138', banco: 'GET MONEY CC LTDA	' },
  { codigo: '139', banco: 'INTESA SANPAOLO BRASIL S.A. BM	' },
  { codigo: '140', banco: 'NU INVEST CORRETORA DE VALORES S.A.	' },
  { codigo: '142', banco: 'BROKER BRASIL CC LTDA.	' },
  { codigo: '143', banco: 'TREVISO CC S.A.	' },
  { codigo: '144', banco: 'BEXS BCO DE CAMBIO S.A.	' },
  { codigo: '145', banco: 'LEVYCAM CCV LTDA	' },
  { codigo: '146', banco: 'GUITTA CC LTDA	' },
  { codigo: '149', banco: 'FACTA S.A. CFI	' },
  { codigo: '157', banco: 'ICAP DO BRASIL CTVM LTDA.	' },
  { codigo: '159', banco: 'CASA CREDITO S.A. SCM	' },
  { codigo: '163', banco: 'COMMERZBANK BRASIL S.A. - BCO MÚLTIPLO	' },
  { codigo: '173', banco: 'BRL TRUST DTVM SA	' },
  { codigo: '174', banco: 'PEFISA S.A. - C.F.I.	' },
  { codigo: '177', banco: 'GUIDE	' },
  { codigo: '180', banco: 'CM CAPITAL MARKETS CCTVM LTDA	' },
  { codigo: '183', banco: 'SOCRED SA - SCMEPP	' },
  { codigo: '188', banco: 'ATIVA S.A. INVESTIMENTOS CCTVM	' },
  { codigo: '189', banco: 'HS FINANCEIRA	' },
  { codigo: '190', banco: 'SERVICOOP	' },
  { codigo: '191', banco: 'NOVA FUTURA CTVM LTDA.	' },
  { codigo: '194', banco: 'PARMETAL DTVM LTDA	' },
  { codigo: '195', banco: 'VALOR SCD S.A.	' },
  { codigo: '196', banco: 'FAIR CC S.A.	' },
  { codigo: '197', banco: 'STONE IP S.A.	' },
  { codigo: '212', banco: 'BANCO ORIGINAL	' },
  { codigo: '213', banco: 'BCO ARBI S.A.	' },
  { codigo: '217', banco: 'BANCO JOHN DEERE S.A.	' },
  { codigo: '218', banco: 'BCO BS2 S.A.	' },
  { codigo: '222', banco: 'BCO CRÉDIT AGRICOLE BR S.A.	' },
  { codigo: '224', banco: 'BCO FIBRA S.A.	' },
  { codigo: '233', banco: 'BANCO CIFRA	' },
  { codigo: '241', banco: 'BCO CLASSICO S.A.	' },
  { codigo: '243', banco: 'BANCO MASTER	' },
  { codigo: '246', banco: 'BCO ABC BRASIL S.A.	' },
  { codigo: '249', banco: 'BANCO INVESTCRED UNIBANCO S.A.	' },
  { codigo: '250', banco: 'BCV - BCO CRÉDITO E VAREJO S.A.	' },
  { codigo: '253', banco: 'BEXS CC S.A.	' },
  { codigo: '254', banco: 'PARANA BCO S.A.	' },
  { codigo: '259', banco: 'MONEYCORP BCO DE CÂMBIO S.A.	' },
  { codigo: '265', banco: 'BCO FATOR S.A.	' },
  { codigo: '266', banco: 'BCO CEDULA S.A.	' },
  { codigo: '268', banco: 'BARI CIA HIPOTECÁRIA	' },
  { codigo: '269', banco: 'BCO HSBC S.A.	' },
  { codigo: '270', banco: 'SAGITUR CC LTDA	' },
  { codigo: '271', banco: 'IB CCTVM S.A.	' },
  { codigo: '272', banco: 'AGK CC S.A.	' },
  { codigo: '273', banco: 'CCR DE SÃO MIGUEL DO OESTE	' },
  { codigo: '274', banco: 'MONEY PLUS SCMEPP LTDA	' },
  { codigo: '276', banco: 'BCO SENFF S.A.	' },
  { codigo: '278', banco: 'GENIAL INVESTIMENTOS CVM S.A.	' },
  { codigo: '279', banco: 'CCR DE PRIMAVERA DO LESTE	' },
  { codigo: '280', banco: 'WILL FINANCEIRA S.A.CFI	' },
  { codigo: '281', banco: 'CCR COOPAVEL	' },
  { codigo: '283', banco: 'RB INVESTIMENTOS DTVM LTDA.	' },
  { codigo: '285', banco: 'FRENTE CC LTDA.	' },
  { codigo: '286', banco: 'CCR DE OURO	' },
  { codigo: '288', banco: 'CAROL DTVM LTDA.	' },
  { codigo: '289', banco: 'EFX CC LTDA.	' },
  { codigo: '290', banco: 'PAGSEGURO INTERNET IP S.A.	' },
  { codigo: '292', banco: 'BS2 DTVM S.A.	' },
  { codigo: '293', banco: 'LASTRO RDV DTVM LTDA	' },
  { codigo: '296', banco: 'VISION S.A. CC	' },
  { codigo: '298', banco: 'VIPS CC LTDA.	' },
  { codigo: '299', banco: 'BCO SOROCRED S.A. - BM	' },
  { codigo: '300', banco: 'BCO LA NACION ARGENTINA	' },
  { codigo: '301', banco: 'BPP IP S.A.	' },
  { codigo: '306', banco: 'PORTOPAR DTVM LTDA	' },
  { codigo: '307', banco: 'TERRA INVESTIMENTOS DTVM	' },
  { codigo: '309', banco: 'CAMBIONET CC LTDA	' },
  { codigo: '310', banco: 'VORTX DTVM LTDA.	' },
  { codigo: '311', banco: 'DOURADA CORRETORA	' },
  { codigo: '312', banco: 'HSCM SCMEPP LTDA.	' },
  { codigo: '313', banco: 'AMAZÔNIA CC LTDA.	' },
  { codigo: '315', banco: 'PI DTVM S.A.	' },
  { codigo: '318', banco: 'BCO BMG S.A.	' },
  { codigo: '319', banco: 'OM DTVM LTDA	' },
  { codigo: '320', banco: 'BCO CCB BRASIL S.A.	' },
  { codigo: '321', banco: 'CREFAZ SCMEPP LTDA	' },
  { codigo: '322', banco: 'CCR DE ABELARDO LUZ	' },
  { codigo: '324', banco: 'CARTOS SCD S.A.	' },
  { codigo: '325', banco: 'ÓRAMA DTVM S.A.	' },
  { codigo: '326', banco: 'PARATI - CFI S.A.	' },
  { codigo: '328', banco: 'CECM FABRIC CALÇADOS SAPIRANGA	' },
  { codigo: '329', banco: 'QI SCD S.A.	' },
  { codigo: '330', banco: 'BANCO BARI S.A.	' },
  { codigo: '331', banco: 'FRAM CAPITAL DTVM S.A.	' },
  { codigo: '332', banco: 'ACESSO SOLUCOES PAGAMENTO SA	' },
  { codigo: '335', banco: 'BANCO DIGIO	' },
  {
    codigo: '340',
    banco: 'SUPER PAGAMENTOS E ADMINISTRACAO DE MEIOS ELETRONICOS S.A.	',
  },
  { codigo: '342', banco: 'CREDITAS SCD	' },
  { codigo: '343', banco: 'FFA SCMEPP LTDA.	' },

  { codigo: '349', banco: 'AL5 S.A. CFI	' },
  { codigo: '350', banco: 'CREHNOR LARANJEIRAS	' },
  { codigo: '352', banco: 'TORO CTVM S.A.	' },
  { codigo: '354', banco: 'NECTON INVESTIMENTOS S.A CVM	' },
  { codigo: '355', banco: 'ÓTIMO SCD S.A.	' },
  { codigo: '358', banco: 'MIDWAY S.A. - SCFI	' },
  { codigo: '359', banco: 'ZEMA CFI S/A	' },
  { codigo: '360', banco: 'TRINUS CAPITAL DTVM	' },
  { codigo: '362', banco: 'CIELO S.A.	' },
  { codigo: '363', banco: 'SINGULARE CTVM S.A.	' },
  { codigo: '364', banco: 'GERENCIANET	' },
  { codigo: '365', banco: 'SIMPAUL	' },
  { codigo: '366', banco: 'BCO SOCIETE GENERALE BRASIL	' },
  { codigo: '367', banco: 'VITREO DTVM S.A.	' },
  { codigo: '368', banco: 'BCO CSF S.A.	' },
  { codigo: '370', banco: 'BCO MIZUHO S.A.	' },
  { codigo: '371', banco: 'WARREN CVMC LTDA	' },
  { codigo: '373', banco: 'UP.P SEP S.A.	' },
  { codigo: '374', banco: 'REALIZE CFI S.A.	' },
  { codigo: '376', banco: 'BCO J.P. MORGAN S.A.	' },
  { codigo: '377', banco: 'BMS SCD S.A.	' },
  { codigo: '378', banco: 'BCO BRASILEIRO DE CRÉDITO S.A.	' },
  { codigo: '379', banco: 'CECM COOPERFORTE	' },
  { codigo: '381', banco: 'BCO MERCEDES-BENZ S.A.	' },
  { codigo: '382', banco: 'FIDUCIA SCMEPP LTDA	' },
  { codigo: '383', banco: 'EBANX IP LTDA.	' },
  { codigo: '384', banco: 'GLOBAL SCM LTDA	' },
  { codigo: '385', banco: 'CECM DOS TRAB.PORT. DA G.VITOR	' },
  { codigo: '386', banco: 'NU FINANCEIRA S.A. CFI	' },
  { codigo: '387', banco: 'BCO TOYOTA DO BRASIL S.A.	' },
  { codigo: '389', banco: 'BCO MERCANTIL DO BRASIL S.A.	' },
  { codigo: '390', banco: 'BCO GM S.A.	' },
  { codigo: '391', banco: 'CCR DE IBIAM	' },
  { codigo: '393', banco: 'BCO VOLKSWAGEN S.A	' },
  { codigo: '394', banco: 'BCO BRADESCO FINANC. S.A.	' },
  { codigo: '395', banco: 'F D GOLD DTVM LTDA	' },
  { codigo: '396', banco: 'HUB PAGAMENTOS	' },
  { codigo: '397', banco: 'LISTO SCD S.A.	' },
  { codigo: '398', banco: 'IDEAL CTVM S.A.	' },
  { codigo: '399', banco: 'KIRTON BANK	' },
  { codigo: '400', banco: 'COOP CREDITAG	' },
  { codigo: '401', banco: 'IUGU IP S.A.	' },
  { codigo: '402', banco: 'COBUCCIO SCD S.A.	' },
  { codigo: '403', banco: 'CORA SCD S.A.	' },
  { codigo: '404', banco: 'SUMUP SCD S.A.	' },
  { codigo: '406', banco: 'ACCREDITO SCD S.A.	' },
  { codigo: '407', banco: 'ÍNDIGO INVESTIMENTOS DTVM LTDA.	' },
  { codigo: '408', banco: 'BONUSPAGO SCD S.A.	' },
  { codigo: '410', banco: 'PLANNER SCM S.A.	' },
  { codigo: '411', banco: 'VIA CERTA FINANCIADORA S.A. - CFI	' },
  { codigo: '412', banco: 'SOCIAL BANK S/A	' },
  { codigo: '413', banco: 'BCO BV S.A.	' },
  { codigo: '414', banco: 'WORK SCD S.A.	' },
  { codigo: '416', banco: 'LAMARA SCD S.A.	' },
  { codigo: '418', banco: 'ZIPDIN SCD S.A.	' },
  { codigo: '419', banco: 'NUMBRS SCD S.A.	' },
  { codigo: '421', banco: 'CC LAR CREDI	' },
  { codigo: '423', banco: 'COLUNA S.A. DTVM	' },
  { codigo: '425', banco: 'SOCINAL S.A. CFI	' },
  { codigo: '426', banco: 'BIORC FINANCEIRA - CFI S.A.	' },
  { codigo: '427', banco: 'CRED-UFES	' },
  { codigo: '428', banco: 'CRED-SYSTEM SCD S.A.	' },
  { codigo: '429', banco: 'CREDIARE CFI S.A.	' },
  { codigo: '430', banco: 'CCR SEARA	' },
  { codigo: '433', banco: 'BR-CAPITAL DTVM S.A.	' },
  { codigo: '435', banco: 'DELCRED SCD S.A.	' },
  { codigo: '438', banco: 'PLANNER TRUSTEE DTVM LTDA	' },
  { codigo: '439', banco: 'ID CTVM	' },
  { codigo: '440', banco: 'CREDIBRF COOP	' },
  { codigo: '442', banco: 'MAGNETIS - DTVM	' },
  { codigo: '443', banco: 'CREDIHOME SCD	' },
  { codigo: '444', banco: 'TRINUS SCD S.A.	' },
  { codigo: '445', banco: 'PLANTAE CFI	' },
  { codigo: '447', banco: 'MIRAE ASSET CCTVM LTDA	' },
  { codigo: '448', banco: 'HEMERA DTVM LTDA.	' },
  { codigo: '449', banco: 'DMCARD SCD S.A.	' },
  { codigo: '450', banco: 'FITBANK PAGAMENTOS ELETRONICOS S.A.	' },
  { codigo: '451', banco: 'J17 - SCD S/A	' },
  { codigo: '452', banco: 'CREDIFIT SCD S.A.	' },
  { codigo: '454', banco: 'MÉRITO DTVM LTDA.	' },
  { codigo: '456', banco: 'BCO MUFG BRASIL S.A.	' },
  { codigo: '457', banco: 'UY3 SCD S/A	' },
  { codigo: '458', banco: 'HEDGE INVESTMENTS DTVM LTDA.	' },
  { codigo: '459', banco: 'CCM SERV. PÚBLICOS SP	' },
  { codigo: '460', banco: 'UNAVANTI SCD S/A	' },
  { codigo: '461', banco: 'ASAAS IP S.A.	' },
  { codigo: '462', banco: 'STARK SCD S.A.	' },
  { codigo: '463', banco: 'AZUMI DTVM	' },
  { codigo: '464', banco: 'BCO SUMITOMO MITSUI BRASIL S.A.	' },
  { codigo: '465', banco: 'CAPITAL CONSIG SCD S.A.	' },
  { codigo: '467', banco: 'MASTER S/A CCTVM	' },
  { codigo: '468', banco: 'PORTOSEG S.A. CFI	' },
  { codigo: '469', banco: 'LECCA DTVM LTDA	' },
  { codigo: '470', banco: 'CDC SOCIEDADE DE CRÉDITO	' },
  { codigo: '473', banco: 'BCO CAIXA GERAL BRASIL S.A.	' },
  { codigo: '477', banco: 'CITIBANK N.A.	' },
  { codigo: '478', banco: 'GAZINCRED S.A. SCFI	' },
  { codigo: '479', banco: 'BCO ITAUBANK S.A.	' },
  { codigo: '487', banco: 'DEUTSCHE BANK S.A.BCO ALEMAO	' },
  { codigo: '488', banco: 'JPMORGAN CHASE BANK	' },
  { codigo: '492', banco: 'ING BANK N.V.	' },
  { codigo: '495', banco: 'BCO LA PROVINCIA B AIRES BCE	' },
  { codigo: '505', banco: 'BCO CREDIT SUISSE S.A.	' },
  { codigo: '536', banco: 'NEON CTVM S.A.	' },
  { codigo: '545', banco: 'SENSO CCVM S.A.	' },
  { codigo: '600', banco: 'BCO LUSO BRASILEIRO S.A.	' },
  { codigo: '604', banco: 'BCO INDUSTRIAL DO BRASIL S.A.	' },
  { codigo: '610', banco: 'BCO VR S.A.	' },
  { codigo: '611', banco: 'BCO PAULISTA S.A.	' },
  { codigo: '612', banco: 'BCO GUANABARA S.A.	' },
  { codigo: '613', banco: 'OMNI BANCO S.A.	' },
  { codigo: '623', banco: 'BANCO PAN	' },
  { codigo: '626', banco: 'BCO C6 CONSIG	' },
  { codigo: '630', banco: 'BCO LETSBANK S.A.	' },
  { codigo: '633', banco: 'BCO RENDIMENTO S.A.	' },
  { codigo: '634', banco: 'BCO TRIANGULO S.A.	' },
  { codigo: '637', banco: 'BCO SOFISA S.A.	' },
  { codigo: '643', banco: 'BCO PINE S.A.	' },
  { codigo: '652', banco: 'ITAÚ UNIBANCO HOLDING S.A.	' },
  { codigo: '653', banco: 'BANCO VOITER	' },
  { codigo: '654', banco: 'BCO DIGIMAIS S.A.	' },
  { codigo: '707', banco: 'BCO DAYCOVAL S.A	' },
  { codigo: '712', banco: 'BCO OURINVEST S.A.	' },
  { codigo: '720', banco: 'BCO RNX S.A.	' },
  { codigo: '739', banco: 'BCO CETELEM S.A.	' },
  { codigo: '741', banco: 'BCO RIBEIRAO PRETO S.A.	' },
  { codigo: '743', banco: 'BANCO SEMEAR	' },
  { codigo: '745', banco: 'BCO CITIBANK S.A.' },
  { codigo: '746', banco: 'BCO MODAL S.A.' },
  { codigo: '747', banco: 'BCO RABOBANK INTL BRASIL S.A.' },
  { codigo: '748', banco: 'BCO COOPERATIVO SICREDI S.A.' },
  { codigo: '751', banco: 'SCOTIABANK BRASIL' },
  { codigo: '752', banco: 'BCO BNP PARIBAS BRASIL S A' },
  { codigo: '753', banco: 'NOVO BCO CONTINENTAL S.A. - BM' },
  { codigo: '754', banco: 'BANCO SISTEMA' },
  { codigo: '755', banco: 'BOFA MERRILL LYNCH BM S.A.' },
  { codigo: '757', banco: 'BCO KEB HANA DO BRASIL S.A.' },
];
